<template>
    <div class="terms">
        <div class="terms__card">
            <div class="terms__title">
                Allgemeine Nutzungsbedingungen
            </div>

            <div class="terms__content" v-html="anb">
                {{anb}}
            </div>

            <hr>

            <div class="terms__checkbox">
                <input type="checkbox" id="readTerms" v-model="termsAccepted">
                <label for="readTerms">ich habe die ANB gelesen und verstanden</label>
            </div>

            <button @click="submit()">Ich akzeptiere die ANB</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            termsAccepted: false
        }
    },
    props: {
        path: {
            type: String,
            default: '/home'
        }
    },
    computed: {
        anb() {
            return this.$store.getters['user/anb'];
        }
    },
    methods: {
        submit() {
            if (this.termsAccepted) {
                this.$store.dispatch('user/acceptanb', { path: this.path });
            } else {
                this.$store.dispatch('notifications/notification', {
                    msg: 'Bitte Haken Setzen',
                    error: true,
                    time: 2000
                });
            }
        }
    },
    created() {
        this.$store.dispatch('user/anb');
        this.$store.dispatch('menu/menuItems');
    }
}
</script>

<style scoped lang="scss">
    .terms {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .terms__card {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0.625rem;
        height: 100vh;

        @include medium {
            width: 31rem;
        }

        @include extra-large {
            width: 700px;
        }
    }

    .terms__title {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.25rem;
        background-color: $color-gray;
        color: $color-white;

    }

    .terms__content {
        flex: 1;
        overflow-y: scroll;
        padding: 0.625rem;
        font-size: 1.25rem;
    }

    .terms__checkbox {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: 1rem;
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;
    }
</style>
